import axios from 'axios';
const axios2 = axios.create({
    baseURL: process.env.REACT_APP_SUMADI_APP_SERVER_URL_V2,
});
const token = localStorage.getItem('session');
if (token) {
    axios2.interceptors.request.use((config) => {
        var _a;
        config.headers = (_a = config.headers) !== null && _a !== void 0 ? _a : {};
        config.headers.Authorization = `${token}`;
        return config;
    });
}
export default axios2;
export const source = axios.CancelToken.source();
